export default `
query QueryShiftTemplatesByServiceProviderIdIndex($serviceProviderId: ID!) {
  queryShiftTemplatesByServiceProviderIdIndex(serviceProviderId: $serviceProviderId) {
    items {
      templateId
      displayName
      userId
      propertyId
      time {
        duration
        startHours
        startMinutes
      }
      note
      requiredLevels
      serviceProviderId
      timezone
      postOrders {
        description
        time {
          start
          end
        }
        propertyId
        dar {
          isRequired
          darId
        }
        completed {
          timestamp
          coordinates {
            lat
            lng
          }
        }
      }
    }
    nextToken
  }
}
`;